import React, { FC } from 'react';
import { ReactComponent as SearchLightIcon } from '../../../../assets/images/multiAccount/searchIconLight.svg';
import { ReactComponent as SearchDarkIcon } from '../../../../assets/images/multiAccount/searchIconDark.svg';
import { useAppSelector } from '../../../../hooks/redux';

interface SearchIconProps {
  className?: string;
}

const defaultProps = {
  className: '',
};

export const SearchIcon: FC<SearchIconProps> = ({ className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (true) {
      case colorTheme === 'light': {
        return <SearchLightIcon className={className} />;
      }
      case colorTheme === 'dark': {
        return <SearchDarkIcon className={className} />;
      }
      default: {
        return <SearchLightIcon className={className} />;
      }
    }
  };

  return getIcon(theme);
};

SearchIcon.defaultProps = defaultProps;
